export default __webpack_public_path__ + "static/media/vulnerability.d9c640a3.svg";